import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Dashboard from "./Dashboard";
import UserList from "./UserList";
import BusinessUser from "./BusinessUser";
import Jobs from "./Jobs";
import CategoryList from "./CategoryList";
import Challenges from "./Challenges";
import UpdatePassword from "./UpdatePassword";
import AddNewJob from "./AddNewJob";


const DashboardLayout = ({ onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation();

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  // Map URL paths to header titles
  const pathTitleMap = {
    "/dashboard": "Dashboard",
    "/dashboard/userlist": "User List",
    "/dashboard/business": "Businesses",
    "/dashboard/jobs": "Jobs",
    "/dashboard/categories": "CategoryList",
    "/dashboard/reports": "Reports",
    "/dashboard/changepass": "Change Password",
    "/dashboard/add-new": "Add new Job",
  };

  // Get the current title or fallback
  const [pageTitle, setPageTitle] = useState("Dashboard");

  useEffect(() => {
    const currentPath = location.pathname.toLowerCase();

    // Find matching title; fallback to Dashboard
    const title = pathTitleMap[currentPath] || "Dashboard";
    setPageTitle(title);
  }, [location]);

  return (
    <div className="flex min-h-screen">
      <Sidebar sidebarOpen={sidebarOpen} onLogout={onLogout} toggleSidebar={toggleSidebar} />

      <div className="flex-1 flex flex-col">
        {/* Header with toggle button */}
        <header className="p-4 bg-white shadow flex items-center">
          <button
            onClick={toggleSidebar}
            className="text-[#FE7A36] focus:outline-none md:hidden"
            aria-label="Toggle sidebar"
          >
            {/* Hamburger icon */}
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <h1 className="text-xl font-semibold ml-4">{pageTitle}</h1>
        </header>

        {/* Page content */}
        <main className="flex-1 p-6 bg-gray-50 overflow-auto">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/userlist" element={<UserList />} />
            <Route path="/business" element={<BusinessUser />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/categories" element={<CategoryList />} />
            <Route path="/reports" element={<Challenges />} />
            <Route path="/changepass" element={<UpdatePassword />} />
            <Route path="/add-new" element={<AddNewJob />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
